import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1100px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
              移动抢先看
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">{appData.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-lg">
              {appData.description}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6 max-w-sm">
              {appData.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-xs md:text-sm text-foreground-700">
                  <span className="w-4 h-4 flex items-center justify-center text-primary-500 flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </span>
                  {feat}
                </div>
              ))}
            </div>
            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line"></i>立即体验移动版
            </a>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[280px] aspect-[3/4] rounded-xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20dark%20theme%20news%20app%20interface%20with%20crimson%20red%20accent%20colors%2C%20showing%20headline%20cards%20and%20trending%20topics%20list%2C%20modern%20UI%20design%2C%20editorial%20news%20app%20style%2C%20clean%20layout%20with%20bold%20typography%2C%20device%20floating%20on%20minimal%20warm%20background&width=700&height=933&seq=app-mockup-911-v2&orientation=portrait"
                alt="911黑料网移动端"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}